
import { getSVGIcon } from "~/functions"
import { Operator } from "~/types/operator"

export const clash: Operator = {
	id: 'clash',
	name: 'Clash',
	role: 'Defender',
	org: 'GSUTR',
	squad: 'WOLFGUARD',
	ratings: {
		health: 3,
		speed: 1,
		difficulty: 3
	},
	meta: {
		gender: 'f',
		country: 'uk',
		season: 'Y3S3',
		height: 179,
		weight: 73,
		price: {
			renown: 10000,
			r6credits: 240
		}
	},
	bio: {
		real_name: 'Morowa Evans',
		birthplace: 'London, England'
	},
	svg: {
		contents: '<switch><foreignObject width="1" height="1" x="0" y="0" requiredExtensions="http://ns.adobe.com/AdobeIllustrator/10.0/"></foreignObject><g><path d="M45 45h260v260H45z" style="opacity:.4"></path><path d="M73 73h204v204H73z"></path><path d="M175.5 62.5c-61.856 0-112 50.144-112 112s50.144 112 112 112 112-50.144 112-112-50.144-112-112-112m0 171.5c-32.861 0-59.5-26.639-59.5-59.5s26.639-59.5 59.5-59.5 59.5 26.639 59.5 59.5-26.639 59.5-59.5 59.5" style="fill:#fff"></path><path d="M175.5 72.5c-56.333 0-102 45.667-102 102s45.667 102 102 102 102-45.667 102-102-45.667-102-102-102m0 171.5c-38.384 0-69.5-31.116-69.5-69.5s31.116-69.5 69.5-69.5 69.5 31.116 69.5 69.5-31.116 69.5-69.5 69.5" style="fill:#708090"></path><path d="M45.211 148.01h260v52.5h-260z" style="fill:#fff"></path><path d="M50.711 153.26h249v42h-249z" style="fill:#fff"></path><path d="M50.711 174.26h20.75v21h-20.75zm20.75-21h20.75v21h-20.75zm20.75 21h20.75v21h-20.75zm20.75-21h20.75v21h-20.75zm20.75 21h20.75v21h-20.75zm20.75-21h20.75v21h-20.75zm20.75 21h20.75v21h-20.75zm20.75-21h20.75v21h-20.75zm20.75 21h20.75v21h-20.75zm20.75-21h20.75v21h-20.75zm20.75 21h20.75v21h-20.75zm20.75-21h20.75v21h-20.75z"></path></g></switch>',
		attributes: {
			xmlns: 'http://www.w3.org/2000/svg',
			space: 'preserve',
			viewBox: '0 0 350 350',
			class: 'r6operators r6operators-clash'
		}
	},
	toSVG: function(userAttr){return getSVGIcon(this, userAttr)}
}
